import React, {
  // useState,
  // useEffect
} from 'react'
// import PropTypes from 'prop-types';

// import { useTheme } from '@mui/material/styles';
import {
  Container,
  Box,
  CircularProgress
  // Tab,
  // Tabs,
  // Grid
} from '@mui/material';
// import Container from '@mui/material/Container';


const LoadingSubPane = (props) => {

  let text = ''
  if (props.text) {
    text = props.text
  }


  let showSpinner = true
  if (props.showSpinner === true || props.showSpinner === false) {
    showSpinner = props.showSpinner
  }

  let progress = 100
  if (props.progress) {
    progress = props.progress
  }

  let spin = false
  if (props.spin) {
    spin = true
  }

  // const theme = useTheme();

  const spinner = () => {

    if (spin === true) {
      return (
        <CircularProgress
        variant="indeterminate"
        />
      )
    }
    else if (showSpinner === true) {
      return (
        <CircularProgress
          variant="determinate"
          value={progress}
        />
      )
    }
  }
  return (
    <Container maxWidth="lg"
      sx={{
        minHeight: `calc(100vh - 99px)`,
        height: `calc(100vh - 99px)`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          mt: '-22px'
        }}
      >

        {spinner()}

        <Box
          sx={{
            mt: 1,
            fontSize: '20px',
            fontWeight: 700
          }}
        >
          {text}
        </Box>
      </Box>

    </Container>
  )

};


export default React.memo(LoadingSubPane)